import React from 'react'
import { TabProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'

const YumTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '32px',
      minWidth: 'auto',
      textTransform: 'none',
      borderRadius: '8px',
      fontWeight: 700,
      fontSize: '13px',
      lineHeight: '16px',
      whiteSpace: 'nowrap',
    },
    textColorPrimary: {
      color: theme.palette.text.primary,
    },
    selected: {
      color: 'white !important',
    },
    wrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  }),
)(({ classes, ...props }: TabProps) => {
  return <Tab classes={classes} {...props} />
})

export default YumTab
